import * as React from "react";

import ProjectsTable from "@editor/components/dashboard/projects/ProjectsTable";
import DashboardLayout from "@editor/components/shops-ui/DashboardLayout";
import { trpc } from "@editor/utils/trpc";

import { Outlet } from "react-router-dom";

const AllProjects: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data, isLoading } = trpc.project.listWithStats.useQuery(
    {},
    {
      refetchOnMount: true,
    },
  );

  return (
    <DashboardLayout>
      <ProjectsTable
        title="All Shops"
        subtitle="These are all the shops shared with you across all workspaces."
        projects={data?.projects}
        isLoading={isLoading}
        showWorkspaceColumn
      />
      {children}
      <Outlet />
    </DashboardLayout>
  );
};

export default AllProjects;
